import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { Select, } from '@tencent/tea-component/lib/select';
import classNames from 'classnames';
import { Bubble } from '@tencent/tea-component/lib/bubble';
export function BuyComplexSelect(_a) {
    var _b;
    var props = __rest(_a, []);
    var options = props.options, value = props.value, defaultValue = props.defaultValue;
    /** hasDesc true 下拉框偏移量为28  false 为0 */
    var _c = __read(useState(false), 2), hasDesc = _c[0], setHasDesc = _c[1];
    useEffect(function () {
        var _a, _b, _c;
        var currentValue = (_a = value !== null && value !== void 0 ? value : defaultValue) !== null && _a !== void 0 ? _a : (_b = options[0]) === null || _b === void 0 ? void 0 : _b.value;
        var hasDesc = ((_c = options.find(function (v) { return v.value === currentValue; })) === null || _c === void 0 ? void 0 : _c.desc) || false;
        setHasDesc(Boolean(hasDesc));
    }, [options]);
    var onChange = function (value) {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value);
        var current = options.find(function (v) { return v.value === value; });
        setHasDesc(Boolean(current === null || current === void 0 ? void 0 : current.desc));
    };
    var complexOption = ((_b = options === null || options === void 0 ? void 0 : options.map) === null || _b === void 0 ? void 0 : _b.call(options, function (v) { return (__assign(__assign({}, v), { text: (React.createElement(Bubble, { placement: 'right', content: React.createElement("span", null,
                React.createElement("div", { className: "selection-item" },
                    React.createElement("p", null, v.text),
                    React.createElement("p", { className: "desc" }, v.desc))) },
            React.createElement("div", { className: "selection-item has-icon" }),
            v.image,
            React.createElement("div", { className: "content" },
                React.createElement("p", null,
                    v.tag,
                    v.text),
                v.desc && React.createElement("p", { className: 'desc' }, v.desc)))) })); })) || [];
    return (React.createElement(Select, __assign({}, props, { onChange: onChange, options: complexOption, className: classNames('tea-buy-complex-select', props.className), appearance: "button", matchButtonWidth: true, placementOffset: hasDesc ? '28' : '0', type: "simulate" })));
}
//# sourceMappingURL=BuyComplexSelect.js.map